module.exports = __webpack_public_path__ + "fonts/fdd715b0761f0ae34b6c63108c0312e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/excess.svg
// module id = 2090
// module chunks = 0